// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'X';

interface XProps {
  className?: string;
}

export function X({ className }: XProps) {
  return (
    <svg
      aria-label={TITLE}
      className={className}
      fill="none"
      height="24"
      role="img"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path
        d="M17.175 4h2.761l-6.031 6.777L21 20h-5.554l-4.353-5.592L6.117 20H3.352l6.45-7.25L3 4h5.695l3.93 5.112L17.176 4Zm-.97 14.377h1.529L7.862 5.538H6.219l9.986 12.839Z"
        fill="currentColor"
      />
    </svg>
  );
}
